var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlancoConNombre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 376.19 467.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#fff;}\r\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n        MB con nombre\r\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.53,12.69h0a7,7,0,0,1,7,7V56.27H242.57V19.64A7,7,0,0,1,249.53,12.69Z",
    transform: "translate(-62.57 -12.69)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.72,151l-30.14-20.8a6.94,6.94,0,0,1-1.77-9.67h0a7,7,0,0,1,9.67-1.77l30.14,20.8Z",
    transform: "translate(-62.57 -12.69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.42,79.85,135,51.67a7,7,0,0,1,.91-9.79h0a7,7,0,0,1,9.79.91L169.12,71Z",
    transform: "translate(-62.57 -12.69)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.62,151.86l-7.9-11.44,30.14-20.8a7,7,0,0,1,9.68,1.77h0a7,7,0,0,1-1.78,9.67Z",
    transform: "translate(-62.57 -12.69)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.92,80.68l-10.7-8.88,23.39-28.18a7,7,0,0,1,9.79-.91h0a7,7,0,0,1,.91,9.79Z",
    transform: "translate(-62.57 -12.69)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.11,245c-63.64-2.71-120.83-39.71-150.81-95.91l-1-1.86L92.06,144A178.7,178.7,0,0,1,249.23,49.31h.59A178.49,178.49,0,0,1,407.56,144l1.75,3.27-1.75,3.28A178.5,178.5,0,0,1,242.11,245Zm-136-97.76a164.89,164.89,0,0,0,287.38,0,164.6,164.6,0,0,0-143.68-84h-.55A164.76,164.76,0,0,0,106.12,147.24Z",
    transform: "translate(-62.57 -12.69)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.19,361.8V298h-.26l-11.55,50.65h-8.26L110.57,298h-.26V361.8H97.19V270h18.23l10.89,49.33h.27L137.34,270H156.1V361.8Z",
    transform: "translate(-62.57 -12.69)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.36,361.8V270h13.91V361.8Z",
    transform: "translate(-62.57 -12.69)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.66,290.69V297l-13.39.66v-5.51c0-7.35-2.75-10.63-8.13-10.63s-8.14,3.28-8.14,9.32v50.12c0,6,2.63,9.32,8,9.32s8-3.28,8-10.63V323.88h-7.87V311h21.52v30.05c0,13.91-8,22.05-21.91,22.05S201.1,355,201.1,341.07V290.69c0-13.91,7.87-22.05,21.65-22.05S244.66,276.78,244.66,290.69Z",
    transform: "translate(-62.57 -12.69)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.34,341.2c0,14.44-8.27,21.92-21.65,21.92-13.12,0-21.39-7.48-21.39-21.92V270h13.38v70.85c0,6.69,3,9.18,7.88,9.18s7.87-2.49,7.87-9.18V270h13.91Z",
    transform: "translate(-62.57 -12.69)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.72,282.81v26h20.34v12.86H330.72v27.29h25.2V361.8h-39.1V270h39.1v12.85Z",
    transform: "translate(-62.57 -12.69)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.17,348.68V361.8H369V270h13.91v78.72Z",
    transform: "translate(-62.57 -12.69)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.13,388.7c14.43,0,22.18,8.13,22.18,23.22v1.71c0,10.23-3,16.27-10.37,18.76v.26c8.66,2.63,12.33,9.45,12.33,21.52v3.15c0,15.09-8.13,23.22-23.09,23.22H68.71V388.7Zm-5.51,37.92H87c6.69,0,9.45-3.41,9.45-11.16v-3c0-7.48-2.76-10.89-8.79-10.89h-5Zm0,41.07h6c6.69,0,9.71-3.55,9.71-11.29v-5.12c0-8.13-3-11.8-10.37-11.8H82.62Z",
    transform: "translate(-62.57 -12.69)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.6,480.54l-3-20.86H135.23l-3,20.86H118.31l15.87-91.84H151.9l15.87,91.84Zm-16.53-33.46h11.68l-5.64-38.7h-.4Z",
    transform: "translate(-62.57 -12.69)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.77,441.71h-6.43v38.83H176.43V388.7h20.08c15,0,23.09,8.13,23.09,23.22v6.56c0,9.71-3.41,16.53-9.84,20.21l12.73,41.85h-14.7Zm-6.43-12.86H196c6.69,0,9.71-3.55,9.71-11.29v-4.72c0-7.74-3-11.28-9.71-11.28h-5.64Z",
    transform: "translate(-62.57 -12.69)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.61,441.71h-6.43v38.83H231.27V388.7h20.08c15,0,23.09,8.13,23.09,23.22v6.56c0,9.71-3.41,16.53-9.84,20.21l12.73,41.85h-14.7Zm-6.43-12.86h5.64c6.7,0,9.71-3.55,9.71-11.29v-4.72c0-7.74-3-11.28-9.71-11.28h-5.64Z",
    transform: "translate(-62.57 -12.69)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.74,480.54l-3-20.86H299.37l-3,20.86H282.44l15.88-91.84H316l15.88,91.84Zm-16.53-33.46h11.67l-5.64-38.7h-.39Z",
    transform: "translate(-62.57 -12.69)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.64,467.69h25.58v12.85H337.55V469l25.58-67.44H338.86V388.7h39.36v11.54Z",
    transform: "translate(-62.57 -12.69)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M418.76,480.54l-3-20.86H400.39l-3,20.86H383.47l15.87-91.84h17.72l15.87,91.84Zm-16.53-33.46h11.68l-5.64-38.7h-.4Z",
    transform: "translate(-62.57 -12.69)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.48,78a68.2,68.2,0,1,0,68.21,68.2A68.2,68.2,0,0,0,249.48,78ZM268.24,183.6l-8.64,3.46-11.82-29.68-16.13,16.14V105.23l47,51-23.05-1.73Z",
    transform: "translate(-62.57 -12.69)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlancoConNombre);
export default __webpack_public_path__ + "static/media/logo-blanco-con-nombre.c68f7db953cc87f292ba456124675e2f.svg";
export { ForwardRef as ReactComponent };